// eslint-disable-next-line import/prefer-default-export
export const CLEAN_CASHUP_DATA = 'CLEAN_CASHUP_DATA';
